<template>
  <fragment>
    <list-skeleton
      v-if="sessionsReport.loading && !sessionsReport.hasNext"
      list-type="session"
    />
    <ul
      v-else
      class="dashboard-list color-coded"
      aria-labelledby="sessionsListTitle"
      aria-describedby="sessionsListSubtitle"
    >
      <li v-if="!sessionsReport.sessions.length" class="empty">No Results</li>
      <li
        v-for="session in sessionsReport.sessions"
        v-else
        :key="session.id"
        class="row"
        :class="getSessionClasses(session)"
      >
        <div class="col-9 subject">
          <div class="avatars hide-sm-down">
            <div class="image"></div>
            <div class="image"></div>
          </div>
          <div>
            <div class="primary">{{ getSessionDate(session) }}</div>
            <div class="secondary">{{ getSessionStatus(session) }}</div>
          </div>
        </div>
        <div class="col-3 data right-align">
          <div class="status" :class="getPaymentStatusClass(session)">
            {{ getPaymentStatus(session) }}
          </div>
          <div v-if="session.payment.status === 'Canceled'">N/A</div>
          <div v-else>
            <span class="credits" v-if="session.payment.paidWithSchoolCredit">
              1 <img src="@/assets/icon/icon-credit.svg" alt="Credit" />
            </span>
          </div>
        </div>
      </li>
    </ul>

    <div v-if="!mobile && sessionsReport.hasNext" class="list-progress-bar">
      <div class="value"></div>
      <span class="sr-only">loading</span>
    </div>

    <div
      v-if="sessionsReport.sessions.length > 20 && !sessionsReport.hasNext"
      class="end-of-list"
    >
      <font-awesome-icon :icon="['fas', 'check-circle']" class="icon alt" />
      <p>All Results Loaded</p>
    </div>
  </fragment>
</template>

<script>
import moment from 'moment';
import ListSkeleton from '../../../ListSkeleton.vue';

export default {
  name: 'List',

  components: {
    ListSkeleton
  },

  props: {
    mobile: {
      type: Boolean,
      default: () => false,
    }
  },

  inject: ['sessionsReport'],

  methods: {
    getSessionClasses(session) {
      switch (session.status) {
        case 'AdminCanceled': {
          return 'cancelled';
        }

        case 'UserCanceled':
        case 'UserLateCanceled': {
          return 'cancelled by-student';
        }

        case 'CounselorCanceled': {
          return 'cancelled by-counselor';
        }

        case 'BothNoShow': {
          return 'not-attended by-student by-counselor';
        }

        case 'UserNoShow': {
          return 'not-attended by-student';
        }

        case 'CounselorNoShow': {
          return 'not-attended by-counselor';
        }

        case 'InProgress': {
          return 'in-progress';
        }

        case 'Successful': {
          return 'successful';
        }

        default:
          return '';
      }
    },

    getSessionDate(session) {
      return moment(session.when).format('MM/DD/yyyy [at] h:mma');
    },

    getSessionStatus(session) {
      switch (session.status) {
        case 'Upcoming':
          return 'Upcoming';

        case 'UserCanceled':
          return 'Canceled by user';
        case 'CounselorCanceled':
          return 'Canceled by counselor';
        case 'UserLateCanceled':
          return 'Canceled by user within 24 hours of session';
        case 'AdminCanceled':
          return 'Canceled by BetterMynd admin';

        case 'InProgress':
          return 'Session in progress';

        case 'BothNoShow':
          return 'User and counselor did not attend';
        case 'UserNoShow':
          return 'User did not attend';
        case 'CounselorNoShow':
          return 'Counselor did not attend';

        case 'Successful':
          return 'Successful session';
        default:
          return '';
      }
    },

    getPaymentStatus(session) {
      const counselorAbsent =
        session.status === 'CounselorNoShow' ||
        session.status === 'BothNoShow';

      if (counselorAbsent) {
        if (session.payment.status === 'Paid') {
          return 'PENDING REFUND';
        }
        if (session.payment.status === 'Pending') {
          return 'PENDING CANCEL';
        }
      }

      return session.payment.status.toUpperCase();
    },

    getPaymentStatusClass(session) {
      const counselorAbsent =
        session.status === 'CounselorNoShow' ||
        session.status === 'BothNoShow';
      const paidOrPending =
        session.payment.status === 'Paid' ||
        session.payment.status === 'Pending';

      if (counselorAbsent && paidOrPending) return 'Pending';

      return session.payment.status;
    }
  }
};
</script>
